import React from 'react';
import { FaCode, FaDesktop, FaWrench, FaGraduationCap } from 'react-icons/fa';
import { motion } from 'framer-motion';
import ServiceCard from '../../components/services/ServiceCard';
import ContactCTA from '../../components/services/ContactCTA';
import PricingInfo from '../../components/services/PricingInfo';

const Services = () => {
  const fadeInUp = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.6 }
    }
  };

  const stagger = {
    visible: {
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const servicesData = [
    {
      icon: <FaCode />,
      title: "Développement Web",
      description: "Création de sites web sur-mesure, modernes et responsive pour répondre à vos objectifs professionnels.",
      items: [
        "Sites vitrine pour présenter votre activité",
        "Boutiques en ligne et solutions e-commerce",
        "Applications web personnalisées",
        "Refonte et optimisation de sites existants",
        "Solutions web sur-mesure pour votre entreprise"
      ]
    },
    {
      icon: <FaDesktop />,
      title: "Montage PC sur-mesure",
      description: "Configuration et assemblage de PC personnalisés adaptés à votre budget et à vos besoins spécifiques.",
      items: [
        "Analyse précise de vos besoins et usages",
        "Sélection des composants optimaux pour votre budget",
        "Assemblage soigné et tests de performance",
        "Configuration système complète et optimisée",
        "Conseils d'utilisation et maintenance"
      ]
    },
    {
      icon: <FaWrench />,
      title: "Dépannage Informatique",
      description: "Résolution de problèmes techniques pour maintenir votre équipement informatique en parfait état de fonctionnement.",
      items: [
        "Diagnostic et résolution des problèmes matériels",
        "Élimination des virus et logiciels malveillants",
        "Optimisation des performances système",
        "Récupération de données",
        "Installation et mise à jour de logiciels"
      ]
    },
    {
      icon: <FaGraduationCap />,
      title: "Cours d'Informatique",
      description: "Formation personnalisée pour vous aider à maîtriser votre ordinateur et naviguer sur internet en toute sécurité.",
      items: [
        "Initiation aux bases de l'informatique",
        "Navigation sécurisée sur internet",
        "Utilisation des outils bureautiques",
        "Gestion des e-mails et communication en ligne",
        "Protection de vos données personnelles"
      ]
    }
  ];

  return (
    <div className="flex flex-col min-h-screen bg-gray-900">
      
      <main className="flex-grow pt-8 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <motion.div 
            className="text-center mb-12"
            initial="hidden"
            animate="visible"
            variants={fadeInUp}
          >
            <h1 className="text-4xl font-bold mb-2 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-500">
              Mes Services
            </h1>
            <p className="text-gray-400 max-w-2xl mx-auto">
              Je propose une gamme complète de services informatiques et web adaptés à vos besoins spécifiques.
              Chaque projet est unique et mérite une attention particulière.
            </p>
          </motion.div>
          
          {/* Services Grid */}
          <motion.div 
            className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12"
            variants={stagger}
            initial="hidden"
            animate="visible"
          >
            {servicesData.map((service, index) => (
              <motion.div key={index} variants={fadeInUp}>
                <ServiceCard
                  icon={service.icon}
                  title={service.title}
                  description={service.description}
                  items={service.items}
                />
              </motion.div>
            ))}
          </motion.div>
          
          {/* Contact CTA Section */}
          <ContactCTA />

          {/* Pricing Info */}
          <PricingInfo />
        </div>
      </main>
      
    </div>
  );
};

export default Services;
